import { render } from "./HeroAddEventModal.vue?vue&type=template&id=39a0ea65&scoped=true"
import script from "./HeroAddEventModal.vue?vue&type=script&lang=js"
export * from "./HeroAddEventModal.vue?vue&type=script&lang=js"

import "./HeroAddEventModal.vue?vue&type=style&index=0&id=39a0ea65&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a0ea65"]])

export default __exports__